import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Modal,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Button,
  Col,
} from "reactstrap";
import ConfirmationDialog from "../../components/confirmation.dialog";
// core components
// core components
import ListHeader from "../../components/Headers/ListHeader";
import ErrorMessage from "../../components/Validation/ErrorMessage";
import AdminLayout from "../../layouts/AdminLayout";
import useConditiongetService from "../../services/conditiongetService";
import useDeleteService from "../../services/deleteservice";
import useGetService from "../../services/getservice";
import usePostService from "../../services/postservice";
import usePutService from "../../services/putservice";
import SingleSelect from '../../components/Select/SingleSelect';
import Select, { components } from 'react-select';
import Loader from "../../components/Loader/Loader";
import { validate_email } from "../../helpers/utils";
import useDebounce from "../../components/custom-hooks/useDebounce";
import { MenuListFooter, MenuList } from "../../helpers/selectpaginationhelper";
import useParallelService from "../../services/useParallelService";
import ViewDetailsModal from "./ViewDetailsModal";
import AddAttorneyModal from "./AddAttorneyModal";
import EditAttorneyModal from "./EditAttorneyModal";
import { useQueryClient } from "react-query";

const LawFirmManagementList = () => {
  const queryClient = useQueryClient();
  const [deleteAttorney, setDeleteAttorney] = useState(false);
  let [userModal, setUserModal] = useState(false);
  const [addAttorney, setAddAttorney] = useState({
    first_name: "",
    last_name: "",
    // phone: 0,
    email: "",
    phone: "",
    role: 0,
    is_suspend: 1,
    city: '',
    state: '',
    zipcode: '',
    street_address: ''
  });
  const [editModal, setEditModal] = useState("");
  const [attorneyList, setAttorneyList] = useState([]);
  const [roleList, setRoleList] = useState([]);

  const [selectedAttorneyList, setSelectedAttorneyList] = useState(null);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [getListData, setListData] = useState(false);

  const [sortName, setSortName] = useState("");
  const [totalPage, settotalPage] = useState(0);
  const [page, setPage] = useState(1);

  const [asc, setAsc] = useState("asc");

  const [searchInput, setSearchInput] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);

  const searchItems = (searchValue) => {
    setSearchInput(searchValue);
    setListData(true);
    // if (searchInput !== "") {
    //   const filteredData = attorneyList.filter((item) => {
    //     return Object.values(item)
    //       .join("")
    //       .toLowerCase()
    //       .includes(searchInput.toLowerCase());
    //   });
    //   setFilteredResults(filteredData);
    // } else {
    //   setFilteredResults(attorneyList);
    // }
  };

  useEffect(() => {
    if (asc === "asc") {
      let sorted = attorneyList.sort((a, b) => a.id - b.id);
      setFilteredResults(sorted);
    } else {
      let sorted = attorneyList.sort((a, b) => b.id - a.id);
      setFilteredResults(sorted);
    }
  }, [asc]);

  const handleSort = (sort) => {
    setSortName(sort);
    if (asc === "asc") {
      setAsc("desc");
    } else {
      setAsc("asc");
    }
    setListData(true);
  };

  const { response } = useGetService(`/api/case/getAllCaseViewList`);

  const { response2: getAttorneys, isFetchItems } = useConditiongetService(
    `api/attendee/getAttorneys?sort_name=${sortName}&sort_order=${asc}&search=${searchInput}&size=20&page=${page}`,
    getListData
  );

  const deletedAttorney = useDeleteService(
    `api/attendee/deleteAttorney/${selectedAttorneyList?.id}`,
    deleteAttorney
  );

  let viewUser = (attorney) => {
    setSelectedAttorneyList(attorney);
    setUserModal(true);
  };
  let [createModal, setCreateModal] = useState(false);
  let createAttorney = (id) => {
    setCreateModal(true);
  };

  useEffect(() => {
    if (response.status === "200-OK") {
      setRoleList(response?.data?.data?.allRoleList.map(roleItem => ({ value: roleItem?.id, label: roleItem?.role })));
      setListData(true);
    }
    // if (parallelResponse.length > 0 && isLoad === true) {
    // setIsLoad(false)
    // if (parallelResponse[0]?.status === 200) {
    //   setRoleList(parallelResponse[0]?.data?.allRoleList.map(roleItem => ({ value: roleItem?.id, label: roleItem?.role })));
    //   setListData(true);
    // }
    // if (parallelResponse[1]?.status === 200) {
    //   let finaldata = parallelResponse[1]?.data.map((item) => {
    //     return {
    //       value: item.state_id,
    //       label: item.state_name,
    //     };
    //   });
    //   setstatedata(finaldata);
    //   setstatetotal(parallelResponse[1]?.totalCount);
    // }
    // }
  }, [response]);

  useEffect(() => {
    if (getAttorneys?.status === "200-OK" && getListData) {
      setListData(false);
      setAttorneyList(getAttorneys.data.data);
      settotalPage(getAttorneys?.data?.totalPages);
      // setStateDetails(true);
    }
  }, [getAttorneys]);

  useEffect(() => {
    if (deletedAttorney.status !== "200-OK" && deletedAttorney !== "") {
      toast.error(deletedAttorney.data.message);
    } else if (deletedAttorney !== "") {
      toast.success(deletedAttorney.data.message);
      setListData(true);
    }
    setSelectedAttorneyList(null);
    setDeleteAttorney(false);
  }, [deletedAttorney]);

  const handleDelete = (id) => {
    setDeleteAttorney(true);
  };

  const onPageChange = (value) => {
    setPage(value)
    setListData(true)
  }

  return (
    <AdminLayout name="Attorney Management">
      {isFetchItems && <Loader></Loader>}
      <ListHeader />

      <ConfirmationDialog
        isOpen={confirmationModal}
        toggle={() => setConfirmationModal(false)}
        action={"Delete"}
        onClick={() => {
          setConfirmationModal(false);
          handleDelete();
        }}
      ></ConfirmationDialog>

      {/* Page content */}
      < Container className="mt--7" fluid >
        {/* Table */}
        < Row >
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <div className="row">
                  <div className="col-md-4">
                    <h3 className="mb-0">Attorney List</h3>
                  </div>
                  <div
                    style={{ textAlign: "right" }}
                    className="col-md-8 align-right"
                  >
                    <div
                      className="mb-0 form-group inline"
                      style={{
                        width: "40%",
                        display: "inline-block",
                        marginRight: "15px",
                      }}
                    >
                      <div className="input-group-alternative input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="fas fa-search"></i>
                          </span>
                        </div>
                        <input
                          placeholder="Search"
                          type="text"
                          className="form-control"
                          onChange={(e) => searchItems(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-2">
                    <div>
                      <button onClick={() => handleSort()}>
                        <i className="fa fa-fw fa-sort"></i>
                        Sort
                      </button>
                    </div>
                  </div> */}
                    {/* <div className="col-md-2">
                    <div
                      onClick={() => {
                        setEditModal("add");
                        createAttorney(1);
                      }}
                    >
                      <h3 className="mb-0" style={{ cursor: 'pointer' }}> Send Invitation </h3>
                    </div>
                  </div> */}

                    <UncontrolledDropdown className="inline">
                      <DropdownToggle
                        className="btn-icon-only text-dark"
                        href="#pablo"
                        role="button"
                        size="sm"
                        color=""
                        onClick={(e) => e.preventDefault()}
                      >
                        <i className="fas fa-ellipsis-v" />
                      </DropdownToggle>
                      <DropdownMenu className="dropdown-menu-arrow" right>
                        <DropdownItem
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                          style={{ display: "none" }}
                        >
                          Make Active
                        </DropdownItem>
                        <DropdownItem
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                          style={{ display: "none" }}
                        >
                          Make Inactive
                        </DropdownItem>

                        <DropdownItem
                          // href="javascript:void(0)"
                          onClick={() => {
                            setEditModal("add");
                            createAttorney(1);
                          }}
                        >
                          Send Invitation
                        </DropdownItem>

                        <DropdownItem
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                          style={{ display: "none" }}
                        >
                          Delete
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </div>
              </CardHeader>
              <Table
                className="align-items-center table-flush"
                responsive
                style={{
                  marginBottom: "25px",
                }}
              >
                <thead className="thead-light">
                  <tr>
                    {/* <th scope="col">
                      ID
                      <i
                        onClick={() => handleSort("id")}
                        className="fa fa-fw fa-sort"
                      ></i>
                    </th> */}
                    <th scope="col">
                      Name
                      <i
                        onClick={() => handleSort("first_name")}
                        className="fa fa-fw fa-sort"
                      ></i>
                    </th>
                    <th scope="col">
                      Email ID
                      <i
                        onClick={() => handleSort("email")}
                        className="fa fa-fw fa-sort"
                      ></i>
                    </th>
                    <th scope="col">
                      Phone No
                      {/* <i
                        onClick={() => handleSort("phone")}
                        className="fa fa-fw fa-sort"
                      ></i> */}
                    </th>
                    <th scope="col">
                      Approved
                      {/* <i
                        onClick={() => handleSort("is_approved")}
                        className="fa fa-fw fa-sort"
                      ></i> */}
                    </th>
                    <th scope="col">
                      Status
                      <i
                        onClick={() => handleSort("is_active")}
                        className="fa fa-fw fa-sort"
                      ></i>
                    </th>

                    <th scope="col" ></th>
                  </tr>
                </thead>
                {searchInput.length > 1
                  ? attorneyList.map((phycisins, index) => {
                    return (
                      <tr key={phycisins.id}>
                        {/* <td>{phycisins.id}</td> */}
                        <td>
                          {phycisins.first_name} {phycisins.last_name}
                        </td>
                        <td>{phycisins.email}</td>
                        <td>{phycisins?.phone || '--'}</td>
                        <td>{phycisins.is_approved == 1 ? 'Active' : 'Inactive'}</td>
                        <td>{phycisins.is_suspend == 1 ? 'Suspend' : phycisins.is_active == 1 ? 'Active' : 'Inactive'}</td>
                        <td className="text-right">
                          <UncontrolledDropdown>
                            <DropdownToggle
                              className="btn-icon-only text-light"
                              href="#pablo"
                              role="button"
                              size="sm"
                              color=""
                              onClick={(e) => e.preventDefault()}
                            >
                              <i className="fas fa-ellipsis-v" />
                            </DropdownToggle>
                            <DropdownMenu
                              className="dropdown-menu-arrow"
                              container="body"
                            >
                              <DropdownItem
                                onClick={() => viewUser(phycisins)}
                              >
                                View
                              </DropdownItem>
                              <DropdownItem
                                onClick={() => {
                                  setEditModal("edit");
                                  setAddAttorney({
                                    first_name: phycisins.first_name,
                                    last_name: phycisins.last_name,
                                    phone: phycisins?.phone || '',
                                    email: phycisins.email,
                                    role: roleList.filter(roleItem => roleItem.value === phycisins.role_id),
                                    status: phycisins?.is_suspend,
                                    city: phycisins.city,
                                    // state: phycisins.state,
                                    state: [{
                                      value: phycisins.state,
                                      label: phycisins.state,
                                    }],
                                    street_address: phycisins.street_address,
                                    zipcode: phycisins.zipcode
                                  });
                                  createAttorney(1);
                                  setSelectedAttorneyList(phycisins);
                                }}
                              >
                                Edit
                              </DropdownItem>
                              {/* <DropdownItem
                                onClick={() => {
                                  setConfirmationModal(true);
                                  setSelectedAttorneyList(phycisins);
                                }}
                              >
                                Delete
                              </DropdownItem> */}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </td>
                      </tr>
                    );
                  })
                  : attorneyList !== undefined &&
                  attorneyList.map((attorney, index) => {
                    return (
                      <tr key={attorney.id}>
                        {/* <td>{attorney.id}</td> */}
                        <td>
                          {attorney.first_name} {attorney.last_name}
                        </td>
                        <td>{attorney.email}</td>
                        <td>{attorney?.phone || '--'}</td>
                        <td>{attorney.is_approved == 1 ? 'Active' : 'Inactive'}</td>
                        <td>{attorney.is_suspend == 1 ? 'Suspend' : attorney.is_active == 1 ? 'Active' : 'Inactive'}</td>
                        <td className="text-right">
                          <UncontrolledDropdown>
                            <DropdownToggle
                              className="btn-icon-only text-light"
                              href="#pablo"
                              role="button"
                              size="sm"
                              color=""
                              onClick={(e) => e.preventDefault()}
                            >
                              <i className="fas fa-ellipsis-v" />
                            </DropdownToggle>
                            <DropdownMenu
                              className="dropdown-menu-arrow"
                              container="body"
                            >
                              <DropdownItem
                                onClick={() => viewUser(attorney)}
                              >
                                View
                              </DropdownItem>
                              <DropdownItem
                                onClick={() => {
                                  setEditModal("edit");
                                  setAddAttorney({
                                    first_name: attorney.first_name,
                                    last_name: attorney.last_name,
                                    phone: attorney?.phone || '',
                                    email: attorney.email,
                                    role: attorney?.role_id,
                                    status: attorney?.is_suspend,
                                    city: attorney?.city ? [{
                                      value: attorney.city,
                                      label: attorney.city,
                                    }] : [],
                                    // state: attorney.state,
                                    state: attorney?.state ? [{
                                      value: attorney.state,
                                      label: attorney.state,
                                    }] : [],
                                    street_address: attorney.street_address,
                                    zipcode: attorney.zipcode
                                  })
                                  createAttorney(1);
                                  setSelectedAttorneyList(attorney);
                                }}
                              >
                                Edit
                              </DropdownItem>
                              {/* <DropdownItem
                                href="#"
                              onClick={() => {
                                setSelectedId(user.email);
                                setResetModal(true);
                              }}
                              >
                                Reset Password
                              </DropdownItem> */}
                              {/* <DropdownItem
                                onClick={() => {
                                  setConfirmationModal(true);
                                  setSelectedAttorneyList(attorney);
                                  // {

                                  // }
                                  // // onClick={() => handleDelete(court?.id)}
                                }}
                              >
                                Delete
                              </DropdownItem> */}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </td>
                      </tr>
                    );
                  })}
              </Table>
              <CardFooter className="py-4">
                {totalPage > 1 ?
                  <nav aria-label="...">
                    <Pagination
                      className="pagination justify-content-end mb-0"
                      listClassName="justify-content-end mb-0"
                    >
                      <PaginationItem
                        // className="disabled"
                        className={page < 2 ? "disabled" : ""}
                      >
                        <PaginationLink
                          href="#pablo"
                          onClick={(e) => {
                            e.preventDefault();
                            onPageChange(page - 2);
                          }}
                          tabIndex="-1"
                        >
                          <i className="fas fa-angle-left" />
                          <span className="sr-only">Previous</span>
                        </PaginationLink>
                      </PaginationItem>
                      {[...Array(totalPage)].map((_, i) => {
                        return (
                          <PaginationItem
                            key={i}
                            // className="active"
                            className={page === i + 1 ? "active" : ""}
                          >
                            <PaginationLink
                              href="#pablo"
                              onClick={(e) => {
                                e.preventDefault();
                                onPageChange(i + 1);
                              }}
                            >
                              {i + 1}
                            </PaginationLink>
                          </PaginationItem>
                        );
                      })}
                      <PaginationItem
                        // className="disabled"
                        className={page + 2 > totalPage ? "disabled" : ""}
                      >
                        <PaginationLink
                          href="#pablo"
                          onClick={(e) => {
                            e.preventDefault();
                            onPageChange(page + 2);
                          }}
                        >
                          <i className="fas fa-angle-right" />
                          <span className="sr-only">Next</span>
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                  : null}
              </CardFooter>
            </Card>
          </div>
        </Row >
      </Container >

      {userModal && <ViewDetailsModal title={'Attorney Information'} isOpen={userModal} attorneyDetail={selectedAttorneyList} roleList={roleList} viewHandler={() => setUserModal(false)} />}

      {editModal === 'add' && <AddAttorneyModal isOpen={editModal === 'add'} addModalHandler={(isSuccess) => {
        if (isSuccess == 1) {
          setEditModal("")
          setListData(true)
        } else { setEditModal("") }
      }} />}

      {editModal === 'edit' && <EditAttorneyModal
        userId={selectedAttorneyList?.id}
        isOpen={editModal === 'edit'}
        roleList={roleList}
        attorneyDetails={addAttorney}
        editModalHandler={(isSuccess) => {
          if (isSuccess == 1) {
            queryClient.removeQueries({ queryKey: ['data', 0] });
            setEditModal("")
            setListData(true)
          } else {
            queryClient.removeQueries({ queryKey: ['data', 0] });
            setEditModal("")
          }
        }} />}

    </AdminLayout >
  );
};

export default LawFirmManagementList;
